import { EnrichedFacet } from "./enrich-facets";

type FacetLayout =
  | { component: "radio" }
  | { component: "range" }
  | { component: "checkbox"; columns?: number };

const FACET_LAYOUT: Record<EnrichedFacet["id"], FacetLayout> = {
  sort: {
    component: "radio",
  },
  size: {
    component: "checkbox",
    columns: 3,
  },
  currentprice: {
    component: "range",
  },
  default: {
    component: "checkbox",
  },
};

export const getFacetLayout = (facet: EnrichedFacet) => {
  return FACET_LAYOUT[facet.id] ?? FACET_LAYOUT.default;
};
